"use client";

import { Grid } from "@huub-web/ui";
import type { FC, Ref } from "react";

import { TemplatesParser } from "../../components";
import type { TemplateCollection } from "../../types";

export type ModelsOverviewTemplateProps = {
  /**
   * The templates to render in the models overview
   */
  templates?: TemplateCollection;
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

/**
 * ModelsOverviewTemplate component
 */
export const ModelsOverviewTemplate: FC<ModelsOverviewTemplateProps> = ({
  templates,
  ref,
  ...props
}) => (
  <Grid ref={ref} variant="twoColumn" {...props}>
    {templates && templates.length > 0 && (
      <TemplatesParser templates={templates} level={1} />
    )}
  </Grid>
);
